<template>
    <div class="row">
        <input-select class="col-12" label="Indicador" ref="tipo" required :options="options.tipo" v-model="form.tipo"/>
        <input-textarea class="col-12" label="Descrição do benefício" :max-length="400" placeholder="Máximo 400 caracteres" ref="descricao" required v-model="form.descricao"/>
        <input-text class="col-12 col-md-3" label="Unidade base" :max-length="10" placeholder="Máximo 10 caracteres" ref="unidade" required v-model="form.unidade"/>
        <input-text class="col-12 col-md-3" label="Valor do indicador" ref="base" required v-model="form.base"/>
        <input-text class="col-12 col-md-3" label="Percentual" ref="percentual" type="number" :min="0" :max="100" required v-model="form.percentual"/>
        <input-money class="col-12 col-md-3" label="Valor do benefício" ref="valor" required v-model="form.valor"/>        
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect.vue";
import InputText from "@/components/inputs/InputText.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";
import InputMoney from "@/components/inputs/InputMoney.vue";

import helpers from "@/common/utils/helpers";

import {FormMixin} from "@/common/mixins/FormMixin";
import cloneDeep from "lodash/cloneDeep";

export default {
    name: "ModalImpactoEconomico",
    mixins: [FormMixin],
    components: {
        InputSelect,
        InputText,
        InputTextarea,
        InputMoney
    },    
    data : () => ({
        form : {
            id: null,
            tipo: null,
            descricao: "",
            unidade: "",
            base: 0,
            percentual: 0,
            valor: 0
        },
        options : {
            tipo : helpers.getTiposImpactoEconomico()
        }
    }),
    methods : {
        salvar : function(){
            let form = cloneDeep(this.form);
            form.valor = helpers.removerValor(form.valor);
            
            if (form.base != null && form.base !== '') {
                let baseStr = String(form.base);
                baseStr = baseStr.replace(',', '.');
                form.base = parseFloat(baseStr);
            }

            this.$emit('salvar', form);
        },
        editar : function(e){
            let form = cloneDeep(e);
            form.valor = helpers.formatarValor(form.valor);
            
            if (form.base != null && form.base !== '') {
                if (typeof form.base === 'number' || (typeof form.base === 'string' && form.base.includes('.'))) {
                    form.base = String(form.base).replace('.', ',');
                }
            }

            this.form = form;
        },
    }
}
</script>
<style lang="">
    
</style>